import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { ContentSpacing } from '@estee/elc-base-theme';

export interface IStarsSimplified {
    percentageRating: number;
    className?: string;
}

const StarsSimpleWrapper = styled.span`
    display: inline-block;
    margin-right: ${ContentSpacing.space8};
    [dir='rtl'] & {
        margin-right: 0;
        margin-left: 0;
    }
`;

const Stars = styled.span`
    display: inline-block;
    margin-right: ${ContentSpacing.space8};
    [dir='rtl'] & {
        margin-right: 0;
        margin-left: 0;
    }
    width: ${(props: IStarsSimplified) => `${props.percentageRating}%`} !important;
`;

export const StarsSimplified = observer((props: IStarsSimplified) => {
    const classNames = classnames('elc-stars-simplified', 'js-stars-simplified', props.className);
    const starClassNames = classnames(
        'elc-stars-simplified-stars',
        'js-stars-simplified-stars',
        props.className
    );

    return (
        <StarsSimpleWrapper className={classNames}>
            <Stars className={starClassNames} percentageRating={props.percentageRating}></Stars>
        </StarsSimpleWrapper>
    );
});
